setAppViewport